<template>
  <span class="ui-cell-inline">
    <AppTableText :text="fileCountLabel" />
    <AppTableText :text="relationshipLabel" />
    <app-status-badge v-for="item in directions" :key="item.key" design="new" :label="directionBadgeLabel(item)" :color="showStatuses && item.status ? item.status.color : null" :tone="showStatuses ? 'neutral' : directionTone(item.direction)" compact />
  </span>
</template>
<script>
import AppTableText from '@/components/AppTableText.vue'

export default {
  name: 'FlightTicketFilesSummary',
  components: { AppTableText },
  props: {
    item: {
      type: Object,
      required: true,
    },
    showStatuses: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    groups() {
      if (this.item.ticket_groups?.length) return this.item.ticket_groups
      return this.fallbackGroups()
    },
    isShared() {
      return this.groups.length === 1 && this.groups[0].is_shared
    },
    fileType() {
      if (this.isShared) return 'shared'
      if (this.groups.length > 1) return 'separate'
      return 'single'
    },
    directions() {
      return this.groups.reduce((items, group) => {
        this.groupDirections(group).forEach(direction => {
          items.push({
            key: `${group.key}-${direction}`,
            direction,
            status: group[direction]?.status || null,
          })
        })
        return items
      }, [])
    },
    fileCountLabel() {
      if (!this.groups.length) return 'No files'
      const count = this.groups.length
      if (this.isShared) return '1 shared file'
      if (count > 1) return `${count} separate files`
      return `${count} ${count === 1 ? 'file' : 'files'}`
    },
    relationshipLabel() {
      if (!this.groups.length) return 'Ticket file unavailable'
      if (this.isShared) return 'Arrival + departure together'
      if (this.groups.length > 1) return 'One file per direction'
      return 'One travel direction'
    },
  },
  methods: {
    fallbackGroups() {
      const arrival = this.item.arrival_ticket_state || {}
      const departure = this.item.departure_ticket_state || {}
      const shared = arrival.file_name
        && departure.file_name
        && arrival.file_name === departure.file_name
      if (shared || arrival.is_shared || departure.is_shared) {
        return [
          {
            key: arrival.file_name || departure.file_name || 'shared-ticket',
            file_name: arrival.file_name || departure.file_name,
            has_arrival: true,
            has_departure: true,
            is_shared: true,
            arrival: { status: arrival.status },
            departure: { status: departure.status },
          },
        ]
      }
      return [
        arrival.is_uploaded && {
          key: `arrival-${arrival.file_name || 'ticket'}`,
          file_name: arrival.file_name,
          has_arrival: true,
          has_departure: false,
          is_shared: false,
          arrival: { status: arrival.status },
          departure: null,
        },
        departure.is_uploaded && {
          key: `departure-${departure.file_name || 'ticket'}`,
          file_name: departure.file_name,
          has_arrival: false,
          has_departure: true,
          is_shared: false,
          arrival: null,
          departure: { status: departure.status },
        },
      ].filter(Boolean)
    },
    groupDirections(group) {
      return ['arrival', 'departure'].filter(direction => group[`has_${direction}`])
    },
    directionBadgeLabel(item) {
      const label = item.direction === 'arrival' ? 'Arrival' : 'Departure'
      return this.showStatuses && item.status?.name ? `${label} · ${item.status.name}` : label
    },
    directionTone(direction) {
      return direction === 'arrival' ? 'green' : 'blue'
    },
  },
}
</script>
